module.exports = __webpack_public_path__ + "static/media/my-vagrant-life-logo.c47b0517.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/my-vagrant-life-logo.png
// module id = 115
// module chunks = 0